// #region import
import { getApp, initializeApp } from 'firebase/app'
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut, sendPasswordResetEmail, confirmPasswordReset } from 'firebase/auth'
import { SET_CURRENT_USER } from './mutations'
// #endregion

// #region store
export default {
  namespaced: true,
  // #region state
  state: {
    currentUser: null,
  },
  // #endregion
  // #region getters
  getters: {},
  // #endregion
  // #region mutations
  mutations: {
    [SET_CURRENT_USER](state, payload) {
      state.currentUser = payload
    },
  },
  // #endregion
  // #region actions
  actions: {
    /**
     * Initialize the Module.
     * @fires initializeApp
     * @async
     */
    initializeModule({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        console.group('🚦')
        console.log('initializeModule', JSON.parse(process.env.VUE_APP_FIREBASE_CONFIG))
        initializeApp(JSON.parse(process.env.VUE_APP_FIREBASE_CONFIG))
        let subdomain
        if (process.env.NODE_ENV === 'development') {
          subdomain = process.env.VUE_APP_SUBDOMAIN
          console.log('development', process.env.VUE_APP_SUBDOMAIN)
        } else {
          subdomain = window.location.host.split('.')[0]
        }
        console.groupEnd()
        dispatch('firestore/getDoc', { app: '[DEFAULT]', path: `firebaseConfig/${subdomain}` }, { root: true })
          .then((documentSnapshot) => {
            initializeApp(documentSnapshot, 'secondary')
            onAuthStateChanged(getAuth(getApp('secondary')), (user) => {
              commit(SET_CURRENT_USER, user)
            })
            resolve()
          })
          .catch(reject)
      })
    },
    /**
     * Asynchronously signs in using an email and password.
     * @fires signInWithEmailAndPassword
     * @param email — The users email address.
     * @param password — The users password.
     * @async
     */
    signInWithEmailAndPassword(_, { email, password }) {
      return new Promise((resolve, reject) => {
        signInWithEmailAndPassword(getAuth(getApp('secondary')), email, password)
          .then(resolve)
          .catch(reject)
      })
    },
    /**
     * Signs out the current user.
     * @fires signOut
     * @async
     */
    signOut() {
      return new Promise((resolve, reject) => {
        signOut(getAuth(getApp('secondary')))
          .then(resolve)
          .catch(reject)
      })
    },
    /**
     * Sends a password reset email to the given email address.
     * @fires sendPasswordResetEmail
     * @param email — The user's email address.
     * @async
     */
    sendPasswordResetEmail(_, { email }) {
      return new Promise((resolve, reject) => {
        sendPasswordResetEmail(getAuth(getApp('secondary')), email)
          .then(resolve)
          .catch(reject)
      })
    },
    /**
     * Completes the password reset process, given a confirmation code and new password.
     * @fires confirmPasswordReset
     * @param oobCode — A confirmation code sent to the user.
     * @param newPassword — The new password.
     * @async
     */
    confirmPasswordReset(_, { oobCode, newPassword }) {
      return new Promise((resolve, reject) => {
        confirmPasswordReset(getAuth(getApp('secondary')), oobCode, newPassword)
          .then(resolve)
          .catch(reject)
      })
    },
  },
  // #endregion
  // #region modules
  modules: {},
  // #endregion
}
// #endregion
